import constants from "../../constants.js";

export const DebtorAgencyVirtualCreditCardConfigurationsProvider = {
  displayName: "Virtual Payment Provider",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.VirtualPaymentProvider",
  optionsAt: "AgencyVirtualPaymentProviderType",
  defaultValue: "ConfermaPay",
  displayAs: constants.DISPLAY_AS.SELECT,
  required: true
}

export const DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId = {
  displayName: "Regional Credentials Identifier (Consumer)",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.RegionalConsumerId",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: false
}

export const DebtorAgencyVirtualCreditCardConfigurationsCacCode = {
  displayName: "CAC code",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CacCode",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
}

export const DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed = {
  displayName: "Custom name to be displayed",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CustomNameDisplayed",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  required: true
}

export const DebtorAgencyVirtualCreditCardConfigurationsSectorTypes = {
  displayName: "Sector Types",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.SectorTypes",
  optionsAt: "AgencySectorTypes",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT
}

export const DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed = {
  displayName: "Providers Allowed",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.ProvidersAllowed",
  optionsAt: "GDSProviders",
  displayAs: constants.DISPLAY_AS.MULTI_SELECT,
  label: "If empty then all providers are allowed"
}

export const DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed = {
  displayName: "Aggregators Allowed",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.AggregatorsAllowed",
  optionsAt: "AggregatorsAllowed",
    displayAs: constants.DISPLAY_AS.O_DATA_SELECT,
    endpoint: "Settings",
    queryOption: "select",
    selectProperty: "HotelRateCategories",
    inputTitle: "Name",
    selectChoiceName: "Name",
    entityIdentifier: "Name",
    searchAllNo: true,
    isMultiSelect: true,
    additionalFilters: {
      "IsAggregator": true
    },
    showOnlySelectedField: true,
    label: "If empty then all aggregators are allowed"
}

export const DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType = {
  displayName: "Apply Virtual Credit Card",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.VirtualCreditCardApplicationType",
  optionsAt: "AgencyApplyVirtualCreditCardType",
  defaultValue: "Disable",
  displayAs: constants.DISPLAY_AS.SELECT,
  required: true
}

export const DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation = {
  displayName: "Payment Information",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.PaymentInformation",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  maxLength: 200,
  validationRegex: "^[\" %$@£&;!+[\\]'¬`\\~|=^*/}\{)(?:#\\w,\.\-\<\>]*$",
  validationMessage: "There are invalid characters",
}

export const DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail = {
  displayName: "Notification Email",
  dataAt:
    "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.NotificationEmail",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
  inputType: "email",
  required: false
}

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType = {
  displayName: "Source Field Type",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.SourceField.Type",
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: "SourceFieldType",
};

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode = {
  displayName: "Source Field Code",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.SourceField.Code",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCodeSub = {
  displayAs: constants.DISPLAY_AS.SUB_HEADING,
  label:
    "Source field code should only be populated if the source field type is Company Reference.",
};

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey = {
  displayName: "Custom Data Key",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.CustomDataKey",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey = {
  displayName: "Report Key",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem.ReportKey",
  displayAs: constants.DISPLAY_AS.TEXT_INPUT,
};

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem = {
  displayName: "Item",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings.$companyReferenceItem",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldType,
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCode,
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingSourceFieldCodeSub,
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingCustomDataKey,
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingReportKey
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "companyReferenceItem",
  canDelete: true,
}

export const DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping = {
  displayName: "Company Reference Mappings",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig.CompanyReferenceMappings",
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem,
  gridCols: [
    { name: "Source Field Type", key: "SourceField.Type" },
    { name: "Source Field Code", key: "SourceField.Code" },
    { name: "Custom Data Key", key: "CustomDataKey" },
    { name: "Report Key", key: "ReportKey" },
  ],
}

export const DebtorAgencyVirtualCreditCardConfigurationsItem = {
  displayName: "Virtual Credit Card Configuration Item",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations.$virtualCCConfig",
  displayAs: constants.DISPLAY_AS.RESOURCE,
  children: [
    DebtorAgencyVirtualCreditCardConfigurationsProvider,
    DebtorAgencyVirtualCreditCardConfigurationsRegionalConsumerId,
    DebtorAgencyVirtualCreditCardConfigurationsCacCode,
    DebtorAgencyVirtualCreditCardConfigurationsCustomNameDisplayed,
    DebtorAgencyVirtualCreditCardConfigurationsSectorTypes,
    DebtorAgencyVirtualCreditCardConfigurationsProvidersAllowed,
    DebtorAgencyVirtualCreditCardConfigurationsAggregatorsAllowed,
    DebtorAgencyVirtualCreditCardConfigurationsVirtualCreditCardApplicationType,
    DebtorAgencyVirtualCreditCardConfigurationsPaymentInformation,
    DebtorAgencyVirtualCreditCardConfigurationsNotificationEmail,
    DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMapping
  ],
  endpoint: "Debtors",
  routeParamId: "debtorId",
  removeParamId: "virtualCCConfig",
  canDelete: true,
} 

export const DebtorAgencyVirtualCreditCardConfigurations = {
  displayName: "Virtual Credit Card Configuration",
  dataAt: "DebtorAgencyVirtualCreditCardConfigurations",
  displayAs: constants.DISPLAY_AS.GRID,
  canCopyItem: true,
  canAddNew: true,
  gridItem: DebtorAgencyVirtualCreditCardConfigurationsItem,
  gridCols: [
    { 
      name: "Provider", 
      key: "VirtualPaymentProvider" 
    },
    { 
      name: "CAC Code", 
      key: "CacCode" 
    },
    { 
      name: "Custom Name", 
      key: "CustomNameDisplayed" 
    },
    { 
      name: "Sector", 
      key: "SectorTypesInfo" 
    }
  ],
};


// WEBPACK FOOTER //
// ./src/config/components/debtors/agencyVirtualCreditCardConfiguration.js